import axios from "axios";
import { getConfig } from "../../../ApiHelpers/ApiDefaultConfig";
import { TestTokenResponse } from "./models";

export const testUserToken = async (): Promise<TestTokenResponse> => {
    const config = getConfig();
    try {
        const response = await axios.post(`/testToken`, {}, config);
        return response
    } catch (error) {
        return error as TestTokenResponse;
    }
};